import runtimeConfig from '../../config';

const autoSettings = {
	autoDiscover: true,
	authority: runtimeConfig.authServer,
	apiHost: runtimeConfig.apiHost,
	clientId: 'unified-ui',
	scope: 'openid offline_access api'
};

export default autoSettings;
